import { InfoPlateVariant } from "fe-shared/src/components";
import { InvoiceStatusCode } from "./types";

export const COMMENT_LENGTH_LIMIT = 500;
export const FLAG_LENGTH_LIMIT = 250;
export const PAGE_SIZE = 20;

export const HST_TAX = 0.13;

export default COMMENT_LENGTH_LIMIT;

export const TRANSFERS_QUERY_KEY = "transfers";
export const TRANSFERS_ACTIVITIES_QUERY_KEY = "transfersActivities";

export const adjustmentReasonOtherCode = "Other";

export const TRANSACTION_EDIT_BUTTON_PORTAL_ID = "transaction-edit-button";
export const DISPOSITION_EDIT_BUTTON_PORTAL_ID = "disposition-edit-button";

export const WARNING_COLOR = "#F2A033";

export type InvoiceStatusesConfigMap = {
  [key in InvoiceStatusCode]?: InfoPlateVariant;
};

export const INVOICE_STATUSES_CONFIG_MAP: InvoiceStatusesConfigMap = {
  [InvoiceStatusCode.Submitted]: "neutral",
  [InvoiceStatusCode.InReview]: "warning",
  [InvoiceStatusCode.InApproval]: "warning",
  [InvoiceStatusCode.Approved]: "active",
};
